import { Circle } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { TextLine } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { Color } from 'theme/enums';

const QuoteStateCell = ({ ...props }: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, 'archived');
  if (!data) {
    return props?.value;
  }

  const { archived } = data;

  const color = archived ? Color.NEUTRAL : Color.SUCCESS;
  const label = archived ? t('labelArchived') : t('labelActive');

  return (
    <TextLine
      text={label}
      color={color}
      decorator={<Circle weight="fill" style={{ fontSize: 10 }} />}
    />
  );
};

export default QuoteStateCell;
